import keys from '@debbie/common/dist/cache/keys.js';
import { getFilterTables } from '@debbie/common/dist/query/index.js';
import { genObjectKey } from '@debbie/common/dist/util/index.js';
import { agentNoticesEntity, agentProposalsEntity } from '../agents/index.js';
import * as api from '../api/query.js';
import { billingAppendixSetupsEntity } from '../billing-appendix-setups/index.js';
import { billingModelsEntity } from '../billing-models/index.js';
import { billingVouchersEntity } from '../billing-vouchers/index.js';
import { billingsEntity } from '../billings/index.js';
import { caseGroupsEntity } from '../case-groups/index.js';
import { caseVouchersEntity } from '../case-vouchers/index.js';
import { casesEntity } from '../cases/index.js';
import { collectorsEntity } from '../collectors/index.js';
import { connectConnectionsEntity, connectMappingsEntity, connectProductsEntity, } from '../connect/index.js';
import { creditorsEntity } from '../creditors/index.js';
import { customersEntity } from '../customers/index.js';
import { documentsEntity } from '../documents/index.js';
import { emailServersEntity } from '../email-servers/index.js';
import { endReasonsEntity } from '../end-reasons/index.js';
import { interactionCategoriesEntity } from '../interaction-categories/index.js';
import { interactionsEntity } from '../interactions/index.js';
import { parkingLotRemarksEntity } from '../parking/index.js';
import { paymentPlansEntity } from '../paymentPlans/index.js';
import { payoutsEntity } from '../payouts/index.js';
import { propertiesEntity, propertyTypesEntity } from '../properties/index.js';
import q from '../query.js';
import { satisfactionsEntity } from '../satisfactions/index.js';
import { tribunalCasesEntity, tribunalJobsEntity } from '../tribunal/index.js';
import { updateTypesEntity } from '../update-types/index.js';
import { updatesEntity } from '../updates/index.js';
import { viewsEntity } from '../views/index.js';
import { voucherTypesEntity } from '../voucher-types/index.js';
import { workflowStagesEntity } from '../workflow-stages/index.js';
import { workflowsEntity } from '../workflows/index.js';
const entityLookup = {
    agentNotices: agentNoticesEntity,
    agentToolCalls: agentProposalsEntity,
    billings: billingsEntity,
    billingAppendices: '', // billingAppendicesEntity,
    billingAppendixSetups: billingAppendixSetupsEntity,
    billingAppendixSetupsOnTenants: '',
    billingCollections: billingsEntity, // billingCollectionsEntity,
    billingModels: billingModelsEntity,
    billingModelsOnTenants: '',
    billingReasons: '', // billingReasonsEntity,
    billingVouchers: billingVouchersEntity,
    blameLogs: '', // blameLogsEntity,
    caseGroups: caseGroupsEntity,
    caseVouchers: caseVouchersEntity,
    cases: casesEntity,
    collectors: collectorsEntity,
    connectCaseMappingUpdates: '',
    connectCaseMappings: connectMappingsEntity,
    connectConnectionUpdates: '',
    connectConnections: connectConnectionsEntity,
    connectEntityMappings: connectMappingsEntity,
    connectPartners: '', // connectPartnersEntity,
    connectProducts: connectProductsEntity,
    cosmoEvents: '', // cosmoEventsEntity,
    creditors: creditorsEntity,
    customers: customersEntity,
    documents: documentsEntity,
    emailServers: emailServersEntity,
    endReasonProxies: '',
    endReasonVisibility: '',
    endReasons: endReasonsEntity,
    files: '', // filesEntity,
    importFiles: '',
    imports: '', // importsEntity,
    importsCore: '',
    importsCoreErrors: '',
    interactionLookup: interactionsEntity,
    interactions: interactionsEntity,
    parkingLotRemarks: parkingLotRemarksEntity,
    paymentIdentifications: '', // paymentIdentificationsEntity,
    paymentMethods: '', // paymentMethodsEntity,
    paymentPlanEntries: paymentPlansEntity,
    paymentPlans: paymentPlansEntity,
    payouts: payoutsEntity,
    procedures: '', // proceduresEntity,
    proceduresOnTenants: '', // proceduresEntity,
    properties: propertiesEntity,
    propertyTypes: propertyTypesEntity,
    satisfactions: satisfactionsEntity,
    templates: '', // templatesEntity,
    templatesOnTenants: '', // templatesEntity,
    transactionAccounts: '', // transactionsAccountsEntity,
    transactionImports: '', // transactionImportsEntity,
    tribunalCases: tribunalCasesEntity,
    tribunalJobs: tribunalJobsEntity,
    updateTypes: updateTypesEntity,
    updateTypesOnTenants: updateTypesEntity,
    updates: updatesEntity,
    urlShorteners: '', // urlShortenersEntity,
    usersOnCustomers: customersEntity,
    voucherApplications: '', // voucherApplicationsEntity,
    voucherTypes: voucherTypesEntity,
    voucherTypesOnTenants: voucherTypesEntity,
    workflows: workflowsEntity,
    workflowsOnTenants: workflowsEntity,
    workflowStages: workflowStagesEntity,
    workflowStagesOnTenants: workflowStagesEntity,
    views: viewsEntity,
    favoritedViews: viewsEntity,
    interactionCategories: interactionCategoriesEntity,
};
const genDeps = (query) => {
    const tables = Object.keys(query.properties);
    tables.push(...getFilterTables(query.filters));
    const uniqueTables = [...new Set(tables)];
    const allKeys = uniqueTables.flatMap((table) => keys.read.collection(entityLookup[table]));
    return allKeys;
};
export const useQuery = (base) => (query) => q.query(genObjectKey(query), () => api.query(base)(query), genDeps(query));
//# sourceMappingURL=index.js.map